import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLogout } from "../store/reducers/userReducer";
import { useNavigate } from "react-router-dom";

const Logout = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setLogout());
        navigate("/")
    }, [])

    return null;
}

export default Logout